export default __webpack_public_path__ + "static/media/logoMenu.37c374fa.svg";